/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { TWG_BRANDING } from '../../../../branding';

import { messages } from './messages';
import { type Tab, TabToggle } from './TabToggle';

export type SectionHeaderProps = {
	selectedTab: Tab;
	onSelectTab: (tab: Tab) => void;
};

const styles = cssMap({
	header: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: token('space.200'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		minHeight: '240px',
		width: '100%',
		textAlign: 'center',
	},
	eyebrow: {
		margin: 0,
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		color: '#8C8F97',
		font: token('font.body'),
		fontFamily: token('font.family.code'),
		fontWeight: token('font.weight.semibold'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		letterSpacing: '1px',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		textTransform: 'uppercase',
	},
	heading: {
		margin: 0,
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		color: '#F0F1F2',
		font: token('font.heading.xxlarge'),
		fontFamily: token('font.family.brand.heading'),
		fontWeight: token('font.weight.regular'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		lineHeight: '48px',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		letterSpacing: '0.5px',
		fontVariantNumeric: 'tabular-nums lining-nums',
	},
});

export const SectionHeader = ({ selectedTab, onSelectTab }: SectionHeaderProps): JSX.Element => (
	<header css={styles.header}>
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
		<p css={styles.eyebrow}>
			{selectedTab === 'mcp' ? (
				<FormattedMessage {...messages.eyebrowMcp} />
			) : (
				<FormattedMessage {...messages.eyebrow} values={{ twg_branding: TWG_BRANDING }} />
			)}
		</p>
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/design-system/use-heading */}
		<h2 css={styles.heading}>
			<FormattedMessage {...messages.heading} />
		</h2>
		<TabToggle selectedTab={selectedTab} onSelectTab={onSelectTab} />
	</header>
);
